import { persist } from 'zustand/middleware';

/**
 * Custom persist middleware with version control
 * Automatically invalidates old data when version changes
 * @param {Function} config - Zustand store config
 * @param {Object} options - Persist options
 * @param {string} options.name - Storage key name
 * @param {number} [options.version] - Version number for invalidation (optional)
 * @param {Function} [options.onRehydrateStorage] - Optional rehydration callback
 * @returns {Function} Persist middleware
 */
export const persistVersioned = (config, options) => {
  const { name, version, onRehydrateStorage, ...restOptions } = options;

  return persist(config, {
    name,
    ...restOptions,
    // Add version to state so we can check it on rehydration
    partialize: (state) => {
      return {
        ...state,
        _version: version,
      };
    },
    onRehydrateStorage: () => (state, error) => {
      // Check version from state - if no version (backwards compatibility) or outdated, treat as non-existent
      if (version !== undefined && state) {
        const persistedVersion = state._version;

        // No version (backwards compat) or version mismatch = treat as non-existent
        if (persistedVersion === undefined || persistedVersion !== version) {
          localStorage.removeItem(name);
          if (onRehydrateStorage) {
            onRehydrateStorage()(null, error);
          }
          return;
        }
      }

      // Normal rehydration
      if (onRehydrateStorage) {
        onRehydrateStorage()(state, error);
      }
    },
  });
};
